import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { UserDeactivationDialogComponent } from './user-deactivation-dialog.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, FormsModule, MatProgressSpinnerModule, MatDialogModule, MatSelectModule, MatButtonModule],
  exports: [UserDeactivationDialogComponent],
  declarations: [UserDeactivationDialogComponent]
})
export class UserDeactivationDialogModule {}
